import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'
import * as filters from '../../filters/index'

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';
import { emailValidator }                from '../../validators/CustomValidators';

import {SalesOfficeDropdownComponent} from '../../components/DomainData/SalesOfficeDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';
import { EmployeeDropdownComponent } from './EmployeeDropdown.component';
import { ApprovalTypeDropdownComponent } from '../DomainData/ApprovalTypeDropdown.component';
import { EmployeesAutoCompleteComponent } from './EmployeesAutoComplete.component';
import { EquipmentClassDropdownComponent } from '../DomainData/EquipmentClassDropdown.component';

@Component({
  selector: 'my-sales-office-approver-edit',
  templateUrl: './SalesOfficeApproverEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => SalesOfficeApproverEditComponent)}]
})
export class SalesOfficeApproverEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;


    @Input() public salesOfficeApprover: ent.SalesOfficeApprover;


    @ViewChild(SalesOfficeDropdownComponent) public salesOfficeDropdown: SalesOfficeDropdownComponent;
    @ViewChild(ApprovalTypeDropdownComponent) public approvalTypeDropdownComponent: ApprovalTypeDropdownComponent;
    @ViewChild(EquipmentClassDropdownComponent) public equipmentClassDropdownComponent: EquipmentClassDropdownComponent;
    @ViewChild(EmployeesAutoCompleteComponent) employeesAutoCompleteComponent: EmployeesAutoCompleteComponent;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder, private employeeService: serv.EmployeeService)
    {
        super();
        let group = {
          'salesOffice' : '',
          'hidSalesOffice' : '',
          'employee' : '',
          'hidEmployee' : '',
          'approvalType' : '',
          'hidApprovalType' : '',
          'equipmentClass' : '',
          'hidEquipmentClass' : '',
          'inactive' : ''
        };

        this.form = fb.group(group);


    }


    ngOnInit(): void {

        this.form.controls.salesOffice.setValidators(dropDownValidator);
        this.form.controls.hidSalesOffice.setValidators(hiddenDropDownValueValidator);

        this.form.controls.hidEmployee.setValidators(hiddenDropDownValueValidator);

        this.form.controls.approvalType.setValidators(dropDownValidator);
        this.form.controls.hidApprovalType.setValidators(hiddenDropDownValueValidator);

        this.form.controls.equipmentClass.setValidators(dropDownValidator);
        this.form.controls.hidEquipmentClass.setValidators(hiddenDropDownValueValidator);

    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){

        this.onOK.emit();

        this.displayDialog = false;

    }

    salesOfficeChange(event: any){
        if (this.salesOfficeApprover){
            this.salesOfficeApprover.SalesOfficeID = event;
        }

    }

    employeeChange(event: any){
      if (this.salesOfficeApprover){
          this.salesOfficeApprover.EmployeeID = event;
      }

    }

    employeesChanged(employeeIDs: number[]){
        if (employeeIDs && employeeIDs.length > 0){
            this.salesOfficeApprover.EmployeeID = employeeIDs[0];
        }
        else{
            this.salesOfficeApprover.EmployeeID = Constants._NONE;
        }
    }

    approvalTypeChange(event: any){
      if (this.salesOfficeApprover){
          this.salesOfficeApprover.ApprovalTypeID = event;
      }
    }

    equipmentClassChange(event: any){
        if (this.salesOfficeApprover){
            this.salesOfficeApprover.EquipmentClassID = event;
        }
      }

    salesOfficeSelected(){
        var val = true;
        var form = this.form;
        if (form.controls.salesOffice.errors && form.controls.hidSalesOffice.errors){
            if (form.controls.salesOffice.errors.invalid && form.controls.hidSalesOffice.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    employeeSelected(){
      var val = true;
      var form = this.form;
      if (form.controls.hidEmployee.errors){
          if (form.controls.hidEmployee.errors.invalid){
              val = false;
          }
      }
      return val;
    }

    approvalTypeSelected(){
      var val = true;
      var form = this.form;
      if (form.controls.approvalType.errors && form.controls.hidApprovalType.errors){
          if (form.controls.approvalType.errors.invalid && form.controls.hidApprovalType.errors.invalid){
              val = false;
          }
      }
      return val;
    }

    equipmentClassSelected(){
        var val = true;
        var form = this.form;
        if (form.controls.equipmentClass.errors && form.controls.hidEquipmentClass.errors){
            if (form.controls.equipmentClass.errors.invalid && form.controls.hidEquipmentClass.errors.invalid){
                val = false;
            }
        }
        return val;
      }

    setEmployeeAutoCompleteValue(employeeID?: number){
        let component = this.employeesAutoCompleteComponent;
        if (component){
            component.employees = [];
            component.selectedEmployeeNumbers = [];
            
            
            if (employeeID){
                var filter: filters.EmployeeFilter = {EmployeeID: employeeID};
                this.employeeService.getEmployees(filter).subscribe(x=>
                {
                    if (x && x.length > 0){
                        var employee = x[0];
                        component.employeesModel = {name: employee.FullNameWithPersonnelNumber, ID: employee.ID};
                    }
                    else {
                        component.onClearClick(null);
                    }
                    
                });
            }
        }
    }

}
